export default __webpack_public_path__ + "static/media/policy07_2023.bac4e83e.jpg";